import ChangeEmailDialogComponent from './change-email.component'

const ChangeEmailDialogModule = angular.module('cdbl.account-change-email', [

])
  .component('cdblAccountChangeEmail', ChangeEmailDialogComponent)
  .name

export default ChangeEmailDialogModule
